import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DeleteProfilePicUseCase extends BaseUseCase {
    constructor(deleteProfilePicRep) {
        super();
        this.deleteProfilePicRep = deleteProfilePicRep;
    }
    async fetchResult(req) {
        return await this.deleteProfilePicRep.deleteProfilePicData(req);
    }
}
export default DeleteProfilePicUseCase;
